import { useState, useEffect } from "react";
import { authFetch } from "../utils/authFetch";

export function useCliente(id) {
  const [cliente, setCliente] = useState(null);
  const [storicoPunti, setStoricoPunti] = useState([]);
  const [storicoConsumi, setStoricoConsumi] = useState([]);
  const [prodotti, setProdotti] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL || "";

  useEffect(() => {
    if (id) {
      fetchCliente();
      fetchProdotti();
    }
  }, [id]);

  const fetchCliente = async () => {
    const res = await authFetch(`${API_URL}/api/clienti/${id}/`);
    if (res.ok) setCliente(await res.json());
  };

  const fetchProdotti = async () => {
  const res = await authFetch(`${API_URL}/api/prodotti/?tipo_listino=cliente`);
  if (res.ok) setProdotti(await res.json());
  else console.error("Errore fetch prodotti", res.status);
};

  const fetchStoricoPunti = async () => {
    const res = await authFetch(`${API_URL}/api/clienti/${id}/punti/storico/`);
    if (res.ok) {
      const json = await res.json();
      setStoricoPunti(Array.isArray(json.storico) ? json.storico : json);
    }
  };

  const fetchStoricoConsumi = async () => {
    const res = await authFetch(`${API_URL}/api/clienti/${id}/consumi/`);
    if (res.ok) {
      const json = await res.json();
      setStoricoConsumi(Array.isArray(json.storico) ? json.storico : json);
    }
  };

  return {
    cliente,
    prodotti,
    storicoPunti,
    storicoConsumi,
    fetchCliente,
    fetchProdotti,
    fetchStoricoPunti,
    fetchStoricoConsumi,
  };
}